import { OpenDepositOptions } from '@/components/Deposit/types'

export const initDepositOptions: OpenDepositOptions = {
  chains: [],
  spotChains: [],
  currentActiveAccount: {
    wallet: 'EVM',
    ethAddress: '',
    accountId: '',
    smartWalletAddress: '',
  },
  defaultChainId: 1,
  defaultAccountType: 'perpetual',
  platformBalance: '0',
}
